export enum ClaimDataTypes {
    STRING = 'String',
    NUMBER = 'Number',
    BOOLEAN = 'Boolean',
    DATE = 'Date',
    DATE_TIME = 'Date/Time',
    TIME = 'Time',
    PERMISSION = 'Permission'
}
